import { createSelector } from '@ngrx/store';

import { parseFullName } from '../../job-helpers';
import { overviewLocationsFeature } from '../../job-overview/overview-locations/overview-locations.feature';

import { CustomerEdit } from './job-create-customer.actions';
import { jobCreateCustomerFeature } from './job-create-customer.feature';

export const selectCustomerEdit = createSelector(
  jobCreateCustomerFeature.selectCustomerEditor,
  overviewLocationsFeature.selectLocationEditors,
  (
    { selectedCustomer, fullName, phone, email, company, additionalContacts },
    locationEditors,
  ): CustomerEdit => {

    const { givenName, familyName } = parseFullName(fullName);

    return {
      selectedCustomer,
      givenName,
      familyName,
      phone,
      email,
      company,
      additionalContacts,
      selectedBillingLocation: locationEditors?.billing?.selectedLocation ? {
        ...locationEditors?.billing?.selectedLocation,
        addressLineTwo: locationEditors?.billing?.unitNumber || locationEditors?.billing?.selectedLocation?.addressLineTwo,
      } : undefined,
    };
  },
);
